/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Send_Tts_MessagesInputs */



/**
* | output |
* | --- |
* | "Send Text-to-speech Messages" |
*
* @param {Leveling_Perm_Send_Tts_MessagesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_send_tts_messages = /** @type {((inputs?: Leveling_Perm_Send_Tts_MessagesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Send_Tts_MessagesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправлять TTS-сообщения")
	return /** @type {LocalizedString} */ ("Send Text-to-speech Messages")
});